import * as DataDog from './DataDog';
import * as Sentry from './Sentry';

init();

function init() {
  if ('Cypress' in window) return;
  if (import.meta.env.NODE_ENV === 'test') return;
  if (import.meta.env.VITE_APP_TARGET === 'local') return;

  try {
    Sentry.init();
  } catch {}

  try {
    DataDog.init();
  } catch {}
}

export function identifyUser(user: Record<string, unknown>) {
  Sentry.identifyUser(user);
  DataDog.identifyUser(user);
}

export function addLogContext(key: string, value: Record<string, unknown>) {
  DataDog.getLogger().setContext({
    [`context.${key}`]: value,
  });
  Sentry.addContext(`context.${key}`, value);
}

export function logInfo(
  message: string,
  messageContext?: Record<string, unknown>,
) {
  DataDog.getLogger().info(message, { message_context: messageContext });
  Sentry.getLogger().info(message, { message_context: messageContext });
}

export function logWarning(
  message: string,
  messageContext?: Record<string, unknown>,
) {
  DataDog.getLogger().warn(message, { message_context: messageContext });
  Sentry.getLogger().warn(message, { message_context: messageContext });
}

export function logError(
  error: unknown,
  source: string,
  messageContext?: Record<string, unknown>,
) {
  const context = { message_context: messageContext, error_source: source };

  if (typeof error === 'string') {
    DataDog.getLogger().error(error, context, new Error(error));

    Sentry.getLogger().error(error, context);
  } else if (error instanceof Error) {
    DataDog.getLogger().error(error.message, context, error);
    Sentry.getLogger().error(error.message, context);
  } else {
    DataDog.getLogger().error(
      'Unknown Error',
      context,
      new Error('Unknown Error'), // create inline Error to include stacktrace
    );
    Sentry.getLogger().error('Unknown Error', context);
  }
}
